<h1 mat-dialog-title>Umstallen</h1>
<div mat-dialog-content>
    <div class="one-column">
        <button mat-stroked-button color="accent" (click)="gruppeAuswahl()" style="margin-top: 12px; width: 100%"
            >in existierende Gruppe</button
        >
        <button mat-stroked-button color="accent" (click)="neueGruppe()" style="margin-top: 12px; width: 100%"
            >in neue Gruppe</button
        >
    </div>
</div>
<div mat-dialog-actions align="end">
    <button (click)="cancel()" mat-button>Abbrechen</button>
</div>
